// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SlugRouteImport } from './routes/$slug'
import { Route as SplatRouteImport } from './routes/$'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SlugIndexRouteImport } from './routes/$slug/index'
import { Route as SlugScoreRouteImport } from './routes/$slug/score'
import { Route as SlugProfileRouteImport } from './routes/$slug/profile'
import { Route as SlugOfferRouteImport } from './routes/$slug/offer'
import { Route as SlugEpisodesRouteImport } from './routes/$slug/episodes'
import { Route as SlugAuthRouteImport } from './routes/$slug/auth'
import { Route as SlugGameEpisodeIdRouteImport } from './routes/$slug/game.$episodeId'
import { Route as SlugAuthResetPasswordRouteImport } from './routes/$slug/auth/reset-password'
import { Route as SlugAuthCallbackRouteImport } from './routes/$slug/auth/callback'

const SlugRoute = SlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => rootRouteImport
          })
const SplatRoute = SplatRouteImport.update({
            id: '/$',path: '/$',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const SlugIndexRoute = SlugIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => SlugRoute
          })
const SlugScoreRoute = SlugScoreRouteImport.update({
            id: '/score',path: '/score',getParentRoute: () => SlugRoute
          })
const SlugProfileRoute = SlugProfileRouteImport.update({
            id: '/profile',path: '/profile',getParentRoute: () => SlugRoute
          })
const SlugOfferRoute = SlugOfferRouteImport.update({
            id: '/offer',path: '/offer',getParentRoute: () => SlugRoute
          })
const SlugEpisodesRoute = SlugEpisodesRouteImport.update({
            id: '/episodes',path: '/episodes',getParentRoute: () => SlugRoute
          })
const SlugAuthRoute = SlugAuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => SlugRoute
          })
const SlugGameEpisodeIdRoute = SlugGameEpisodeIdRouteImport.update({
            id: '/game/$episodeId',path: '/game/$episodeId',getParentRoute: () => SlugRoute
          })
const SlugAuthResetPasswordRoute = SlugAuthResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => SlugAuthRoute
          })
const SlugAuthCallbackRoute = SlugAuthCallbackRouteImport.update({
            id: '/callback',path: '/callback',getParentRoute: () => SlugAuthRoute
          })





const SlugAuthRouteChildren = {
  SlugAuthCallbackRoute: SlugAuthCallbackRoute,SlugAuthResetPasswordRoute: SlugAuthResetPasswordRoute
}

const SlugAuthRouteWithChildren = SlugAuthRoute._addFileChildren(SlugAuthRouteChildren)



const SlugRouteChildren = {
  SlugAuthRoute: SlugAuthRouteWithChildren,SlugEpisodesRoute: SlugEpisodesRoute,SlugOfferRoute: SlugOfferRoute,SlugProfileRoute: SlugProfileRoute,SlugScoreRoute: SlugScoreRoute,SlugIndexRoute: SlugIndexRoute,SlugGameEpisodeIdRoute: SlugGameEpisodeIdRoute
}

const SlugRouteWithChildren = SlugRoute._addFileChildren(SlugRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,SplatRoute: SplatRoute,SlugRoute: SlugRouteWithChildren
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)